import React from 'react';
import _ from 'lodash';

class NumberWidgetCircularSettings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            widget: props.widget,
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            widget: props.widget,
        });
    }

    render() {
        return (
            <div>
                <div className="displaySettings-row">
                    <span className="title">Budget</span>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Hämta från Upsales"
                        value={_.get(this.state.widget, 'displayConfig.budget', '')}
                        onChange={(event) => {
                            this.props.setWidgetFieldValue(
                                'displayConfig.budget',
                                parseInt(event.target.value, 10) || null,
                            );
                        }}
                    />
                </div>
            </div>
        );
    }
}

NumberWidgetCircularSettings.propTypes = {
    widget: React.PropTypes.object,
    setWidgetFieldValue: React.PropTypes.func,
};

export default NumberWidgetCircularSettings;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DisplaySettings/NumberWidgetCircularSettings.jsx
 **/